import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = (category) =>
  api.get(`/products${category ? `?category=${category}` : ""}`).then((r) => r.data);

export const fetchProduct = (slug) =>
  api.get(`/products/${slug}`).then((r) => r.data);

export const createLead = (payload) =>
  api.post("/leads", payload).then((r) => r.data);

export const fetchBlog = (category) =>
  api.get(`/blog${category ? `?category=${category}` : ""}`).then((r) => r.data);

export const fetchBlogPost = (slug) =>
  api.get(`/blog/${slug}`).then((r) => r.data);

export const createCheckoutSession = (product_slug) =>
  api
    .post("/checkout/session", { product_slug, origin_url: window.location.origin })
    .then((r) => r.data);

export const getCheckoutStatus = (session_id) =>
  api.get(`/checkout/status/${session_id}`).then((r) => r.data);
